<template>
	<div class="shadow-sm rounded-2xl overflow-hidden flex items-center gap-4 p-4">
		<div
			class="
				pl-4 relative flex-none
				:after:absolute after:right-0 after:-bottom-[40%] after:size-[18.375rem] after:bg-orange-800 after:rounded-full after:-z-1 after:absolute
			"
		>
			<NuxtIcon
				name="custom/confetti-xs"
				filled
				class="[&_svg]:!w-[8.5625rem] [&_svg]:!h-auto absolute -left-5 -top-4"
			/>
			<ProductRibbonHelp
				v-if="vHelpPrice"
				class="max-w-[4.4375rem]"
				:price="vHelpPrice"
			/>
			<NuxtImg
				src="/images/30th/30th-car.png"
				alt=""
				width="124"
				height="54"
				class="w-[7.75rem] mt-4"
			/>
		</div>
		<div>
			<span class="text-base">
				Díky tomuto produktu <strong>pomáháte přispět</strong> na&nbsp;vozy pro&nbsp;<NuxtImg src="/images/30th/kontobariery-logo.svg" width="179" height="20" class="inline" />
			</span>

			<div class="flex gap-2.5 mt-2.5 flex-wrap">
				<AbsoluteInternalLink
					:to="{name: '30let'}"
					class="btn btn-primary btn-md text-xs"
				>
					Více informací
				</AbsoluteInternalLink>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {RIBBON_VHELP_CLUB_ID} from '#shared/constants';
	import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';

	type Props = {
		product: ProductDetail;
	};

	const props = defineProps<Props>();
	const vHelpPrice = computed(() => props.product.productInHouse?.customerClubDiscounts?.find((discount) => discount.customerClub === RIBBON_VHELP_CLUB_ID)?.discount ?? null);
</script>
